const GET_ENTITIES_REQUEST = 'GET_ENTITIES_REQUEST';
const GET_ENTITIES_SUCCESS = 'GET_ENTITIES_SUCCESS';
const GET_ENTITIES_FAILURE = 'GET_ENTITIES_FAILURE';
const CREATE_ENTITY_REQUEST = 'CREATE_ENTITY_REQUEST';
const CREATE_ENTITY_SUCCESS = 'CREATE_ENTITY_SUCCESS';
const CREATE_ENTITY_FAILURE = 'CREATE_ENTITY_FAILURE';
const UPDATE_ENTITY_REQUEST = 'UPDATE_ENTITY_REQUEST';
const UPDATE_ENTITY_SUCCESS = 'UPDATE_ENTITY_SUCCESS';
const UPDATE_ENTITY_FAILURE = 'UPDATE_ENTITY_FAILURE';
const DELETE_ENTITY_REQUEST = 'DELETE_ENTITY_REQUEST';
const DELETE_ENTITY_SUCCESS = 'DELETE_ENTITY_SUCCESS';
const DELETE_ENTITY_FAILURE = 'DELETE_ENTITY_FAILURE';
const SUBSCRIBE_ENTITIES = 'SUBSCRIBE_ENTITIES';
const UNSUBSCRIBE_ENTITIES = 'UNSUBSCRIBE_ENTITIES';
const SUBSCRIPTION_ENTITY_CREATED = 'SUBSCRIPTION_ENTITY_CREATED';
const SUBSCRIPTION_ENTITY_UPDATED = 'SUBSCRIPTION_ENTITY_UPDATED';
const SUBSCRIPTION_ENTITY_DELETED = 'SUBSCRIPTION_ENTITY_DELETED';

export default {
  GET_ENTITIES_REQUEST,
  GET_ENTITIES_SUCCESS,
  GET_ENTITIES_FAILURE,
  CREATE_ENTITY_REQUEST,
  CREATE_ENTITY_SUCCESS,
  CREATE_ENTITY_FAILURE,
  UPDATE_ENTITY_REQUEST,
  UPDATE_ENTITY_SUCCESS,
  UPDATE_ENTITY_FAILURE,
  DELETE_ENTITY_REQUEST,
  DELETE_ENTITY_SUCCESS,
  DELETE_ENTITY_FAILURE,
  SUBSCRIBE_ENTITIES,
  UNSUBSCRIBE_ENTITIES,
  SUBSCRIPTION_ENTITY_CREATED,
  SUBSCRIPTION_ENTITY_UPDATED,
  SUBSCRIPTION_ENTITY_DELETED
};
